








import Vue from 'vue'
import DeclarationsLayout from '@/UI/AuctionB/Declarations/DeclatarionsLayout.vue'
import { BatchDto } from '@/Application/Batch'
import { Offer } from '@/Infrastructure/Store/AuctionB/Offer'
import { Currency } from '@/Domain/Batch/Currency'
import { ResultasOffer } from '@/Infrastructure/Store/AuctionB/ResultasOffer'
import { SpeciesDto } from '@/Application/Batch/Species/SpeciesDto'

export default Vue.extend({
  name: 'Declarations',
  components: {
    DeclarationsLayout
  },
  data () {
    return {
      continuar: false
    }
  },
  methods: {
    onDeclarationsUpdated ($event: { batches: BatchDto[]; offers: Offer[] }) {
      if ($event.offers.length === 0) {
        this.continuar = false
      }
      if ($event.offers.length !== $event.batches.length) {
        this.continuar = false
      }
      let offersValid = 0
      for (const offer of $event.offers) {
        const relatedBatch = $event.batches.find(current => current.batchId === offer.batchId)
        if (!relatedBatch) {
          return false
        }
        const isOfferValid = this.validateOffer(offer, relatedBatch)
        if (isOfferValid) {
          offersValid++
        }
      }
      this.continuar = offersValid === $event.batches.length
      this.$emit('validForm', this.continuar)
    },
    validateOffer (offer: Offer, relatedBatch: BatchDto): boolean {
      if (offer.global.textBid === '') {
        return false
      }
      const isGlobalOfferValid = this.validateOfferValue(offer.global.numberBid)
      if (isGlobalOfferValid === false) {
        return false
      }
      if (offer.resultasOffers === undefined) {
        return isGlobalOfferValid
      }
      for (const resultasOffer of offer.resultasOffers) {
        const relatedSpecies = relatedBatch.species.find(current => current.internalId === resultasOffer.internalId)
        if (!relatedSpecies) {
          return false
        }
        const isResultasOfferValid = this.validateResultasOffer(resultasOffer, relatedSpecies)
        if (isResultasOfferValid === false) {
          return false
        }
      }
      return true
    },
    validateResultasOffer (resultasOffer: ResultasOffer, relatedSpecies: SpeciesDto): boolean {
      let isValid = true
      if (relatedSpecies.sawOneCost !== '-') {
        isValid = isValid && this.validateOfferValue(resultasOffer.sawOne)
      }
      if (relatedSpecies.sawTwoCost !== '-') {
        isValid = isValid && this.validateOfferValue(resultasOffer.sawTwo)
      }
      if (relatedSpecies.grindedCost !== '-') {
        isValid = isValid && this.validateOfferValue(resultasOffer.grinded)
      }
      return isValid
    },
    validateOfferValue (amount: string | undefined): boolean {
      if (amount === undefined || !amount) {
        return false
      }
      if (amount.indexOf(',') !== amount.length - 3) {
        return false
      }
      try {
        Currency.fromString(amount)
        return true
      } catch {
        return false
      }
    }
  }
})
